module.exports = __webpack_public_path__ + "img/copy.5f19fef4.png";